var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcimaRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15147",
    "data-name": "Group 15147",
    transform: "translate(18449 22659)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4959",
    "data-name": "Rectangle 4959",
    width: 27,
    height: 23,
    rx: 4,
    transform: "translate(-18449 -22632) rotate(-90)",
    fill: "#0d6efd",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38121",
    "data-name": "Path 38121",
    d: "M12.013,8.416l-5.2-5.2-5.2,5.2L0,6.81,6.81,0l6.81,6.81Z",
    transform: "translate(-18432.986 -22652.355) rotate(90)",
    fill: "#0d6efd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcimaRightArrow);
export default __webpack_public_path__ + "static/media/acimaRightArrow.6980a142.svg";
export { ForwardRef as ReactComponent };